import { render, staticRenderFns, recyclableRender, components } from "./Invoice-application.vue?vue&type=template&id=2503450a&scoped=true&"
var renderjs
import script from "./Invoice-application.vue?vue&type=script&lang=js&"
export * from "./Invoice-application.vue?vue&type=script&lang=js&"
import style0 from "./Invoice-application.vue?vue&type=style&index=0&id=2503450a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503450a",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "shop/pages/Invoice-application/Invoice-application.vue"
export default component.exports